<template>
  <div class="px-2 py-6 md:px-8">
    <div class="card-title mb-8 md:card-title">Manage your Budget</div>

    <div class="flex flex-wrap">

      <!-- Available Balance -->
      <speakol-analytics-card
        :title="availableBalance| addComma('$')"
        subTitle="Available Balance"
        icon="speakol-fund-accounting"
        backgroundColor="#DFF2FA"
        color="#0092D7"
        class="sub-card mb-4 lg:mb-0 lg:sub-card"
      >
      </speakol-analytics-card>
    </div>

  </div>

</template>


<script>
export default {
  props: ['availableBalance'],
  computed: {
    vatEnabled () {
      return this.$store.getters['authentication/activeAccount'].actual_vat_percentage > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.card-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.sub-card {
  @apply w-full;
}

/* Medium (md) */
@media (min-width: 768px) {
  .md\:card-title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .lg\:sub-card {
    width: 300px !important;

    @apply mr-4;
  }
}

</style>
